/**
 * Promotion words the admin panel shows, in ONE place (#3350).
 *
 * The list and detail pages each kept their own copy of these maps, and both
 * left out `iap_purchase` — the type of the seeded "Match Unlock" and "Second
 * Look" promotions (migrations 277, 288) — so their Issuance cell was blank.
 * tests/unit/admin/promotion-page-contract.test.ts holds these keys to the
 * database CHECK lists.
 */

export type PromotionSource = 'tester' | 'marketing' | 'referral' | 'support' | 'vip' | 'other';
export type IssuanceType = 'admin_grant' | 'shareable_code' | 'unique_codes' | 'referral_auto' | 'iap_purchase';
export type PromotionStatus = 'draft' | 'active' | 'paused' | 'ended' | 'archived';
export type PromotionTransition = 'activate' | 'pause' | 'resume' | 'end' | 'archive';

export const SOURCE_LABELS: Record<PromotionSource, string> = {
  tester: 'Tester',
  marketing: 'Marketing',
  referral: 'Referral',
  support: 'Support',
  vip: 'VIP',
  other: 'Other',
};

export const ISSUANCE_LABELS: Record<IssuanceType, string> = {
  admin_grant: 'Admin Grant',
  shareable_code: 'Shareable Code',
  unique_codes: 'Unique Codes',
  referral_auto: 'Referral Auto',
  iap_purchase: 'In-App Purchase',
};

/** A label for any value the API sends, including one this build does not know yet. */
export function issuanceLabel(value: string): string {
  return (ISSUANCE_LABELS as Record<string, string>)[value] ?? value;
}

/** The toast says what happened: "Promotion ended", never "endd". */
export const TRANSITION_DONE: Record<PromotionTransition, string> = {
  activate: 'activated',
  pause: 'paused',
  resume: 'resumed',
  end: 'ended',
  archive: 'archived',
};
